
import { useState, useEffect } from 'react';
import { useContentManager } from '../../hooks/useContentManager';

// Varsayılan veriler (admin panelden veri yoksa gösterilecek)
const defaultCollections = [
  {
    title: 'THE SKY MANSION PENTHOUSE',
    subtitle: 'GOLDEN TOWER LUXURY RESIDENCES',
    images: []
  },
  {
    title: 'THE EXECUTIVE PENTHOUSE',
    subtitle: 'GOLDEN TOWER PREMIUM COLLECTION',
    images: []
  },
  {
    title: 'THE ROYAL VILLA',
    subtitle: 'GOLDEN TOWER EXCLUSIVE RESIDENCES',
    images: []
  }
];

export default function LuxuryCollection() {
  const { content, getContentItem } = useContentManager();
  const [currentCollection, setCurrentCollection] = useState(0);
  const [currentImage, setCurrentImage] = useState(0);
  const [collections, setCollections] = useState(defaultCollections);

  // Admin panelden gelen verileri yükle (yalnızca content değişince)
  useEffect(() => {
    // Collection verilerini yükle
    const collectionItems = content
      .filter(
        (item) =>
          item.page === 'home' &&
          item.section === 'luxury-collection' &&
          item.type === 'collection'
      )
      .sort((a, b) => a.order - b.order);

    const nextCollections =
      collectionItems.length > 0
        ? collectionItems.map((item) => {
            const metadata = item.metadata || {};
            return {
              title: item.content || metadata.title || 'Başlık Yok',
              subtitle: metadata.subtitle || 'Alt Başlık Yok',
              images: metadata.images || [item.image_url].filter(Boolean),
            };
          })
        : defaultCollections;

    setCollections((prev) => {
      try {
        const same = JSON.stringify(prev) === JSON.stringify(nextCollections);
        return same ? prev : nextCollections;
      } catch {
        return nextCollections;
      }
    });
  }, [content]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % collections[currentCollection].images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [currentCollection, collections]);

  const goToNextCollection = () => {
    setCurrentCollection((prev) => (prev + 1) % collections.length);
    setCurrentImage(0);
  };

  const goToPrevCollection = () => {
    setCurrentCollection((prev) => (prev - 1 + collections.length) % collections.length);
    setCurrentImage(0);
  };

  // Başlık verisini al
  const titleContent = getContentItem('home', 'luxury-collection-title');
  const sectionTitle = titleContent?.content || 'Branded Luxury Collection';

  return (
    <section className="relative h-screen w-full overflow-hidden bg-black">
      <div className="absolute inset-0">
        <video
          autoPlay
          muted
          loop
          playsInline
          className="w-full h-full object-cover opacity-30"
        >
          <source src="" type="video/mp4" />
        </video>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <div className="w-full max-w-4xl px-8">
          <h2 className="text-white text-4xl md:text-5xl text-center mb-12 font-light tracking-wider">
            <span dangerouslySetInnerHTML={{ __html: sectionTitle }} />
          </h2>

          <div className="relative">
            {collections.map((collection, colIndex) => (
              <div
                key={colIndex}
                className={`transition-opacity duration-500 ${
                  colIndex === currentCollection ? 'opacity-100' : 'opacity-0 absolute inset-0 pointer-events-none'
                }`}
              >
                <div className="relative aspect-[16/10] mb-8 overflow-hidden">
                  {collection.images.map((image, imgIndex) => (
                    <img
                      key={imgIndex}
                      src={image}
                      alt={`${collection.title} ${imgIndex + 1}`}
                      className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-1000 ${
                        imgIndex === currentImage ? 'opacity-100' : 'opacity-0'
                      }`}
                    />
                  ))}
                </div>

                <div className="flex justify-center gap-2 mb-6">
                  {collection.images.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentImage(index)}
                      className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                        index === currentImage ? 'bg-white w-8' : 'bg-white/50'
                      }`}
                      aria-label={`Go to image ${index + 1}`}
                    />
                  ))}
                </div>

                <div className="text-center text-white">
                  <h3 className="text-xl md:text-2xl mb-2 tracking-wide">{collection.title}</h3>
                  <h4 className="text-sm md:text-base text-gray-400 tracking-widest">{collection.subtitle}</h4>
                </div>
              </div>
            ))}

            <button
              onClick={goToPrevCollection}
              className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-12 text-white text-4xl hover:text-gray-300 transition-colors cursor-pointer"
              aria-label="Previous collection"
            >
              ‹
            </button>
            <button
              onClick={goToNextCollection}
              className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-12 text-white text-4xl hover:text-gray-300 transition-colors cursor-pointer"
              aria-label="Next collection"
            >
              ›
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
